/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Loadmessageserror3Inputs */

const en_coinvestments_messages_loadmessageserror3 = /** @type {(inputs: Coinvestments_Messages_Loadmessageserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load older messages. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to load older messages. Please try again." |
*
* @param {Coinvestments_Messages_Loadmessageserror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_loadmessageserror3 = /** @type {((inputs?: Coinvestments_Messages_Loadmessageserror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Loadmessageserror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_loadmessageserror3(inputs)
});
export { coinvestments_messages_loadmessageserror3 as "coInvestments_messages_loadMessagesError" }